// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_6a-0";
export var eligibilityCardNotEligible = "_6a-1";